import Header from '../Header/Header.vue'
import Nav from '../Nav/Nav.vue'
import File from './File/File.vue'
import Manual from './Manual/Manual.vue'

export default {
    name: 'Input',
    components: {
        Header,
        Nav,
        File,
        Manual
    },
    created() {
        this.$gtag.screenview({
            app_name: 'Retailers',
            screen_name: 'Other input',
        })
    }
}